import { FilterInfo } from './filter-info';

export class BdFilterInfo extends FilterInfo {
    constructor(options = {}) {
        // Set default options for Beyond the Daf filter
        const bdOptions = {
            queryId: 'beyond-the-daf-listing',
            perPage: 9,
            showingSelector: '.beyond-the-daf__showing',
            totalSelector: '.beyond-the-daf__total',
            hasSearchSummary: true,
            searchOptions: {
                masechetTextSelector: '.beyond-the-daf__masechet-text',
                categoryDescSelector: '.bd-cat-desc .jet-listing-grid__item',
                masechetSelectSelector: '.beyond-the-daf__select .jet-radio-list__input',
                categorySelectSelector: '.beyond-the-daf__categories .jet-radio-list__input',
                titleSelector: '#beyond-the-daf__title',
                categoryTaxName: 'beyond-the-daf-categories'
            },
            modifyInputValue: true,
            inputValuePrefix: 'masechet%{i%'
        };
        
        // Merge with any user-provided options
        super({ ...bdOptions, ...options });
    }
}

